import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "move-buttons d-flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "keyboard_double_arrow_up", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "keyboard_arrow_up", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "keyboard_arrow_down", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "keyboard_double_arrow_down", -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn-sm btn-link text-primary",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit(_ctx.moveActionEnum.TOP.toLowerCase())), ["prevent"]))
    }, _hoisted_3),
    (!_ctx.onlyTopAndBottom)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn btn-sm btn-link text-primary ms-1",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit(_ctx.moveActionEnum.UP.toLowerCase())), ["prevent"]))
        }, _hoisted_5))
      : _createCommentVNode("", true),
    (!_ctx.onlyTopAndBottom)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "btn btn-sm btn-link text-danger ms-1",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit(_ctx.moveActionEnum.DOWN.toLowerCase())), ["prevent"]))
        }, _hoisted_7))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      class: "btn btn-sm btn-link text-danger ms-1",
      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit(_ctx.moveActionEnum.BOTTOM.toLowerCase())), ["prevent"]))
    }, _hoisted_9)
  ]))
}